import PropTypes from "prop-types";
import { OverflowCell } from "@repo/design-system/components/grids/cells";

import "./DualTextCell.scss";

export const DualTextCell = ({
    primaryText,
    secondaryText,
    rowId,
    className = ""
}) => {

    const secondaryTooltipId = `tt-secondaryText-${rowId ?? ""}`;
    const primaryTooltipId = `tt-primaryText-${rowId ?? ""}`;

    return (
        <div className={`dual-text-cell ${className}`.trim()}>
            <OverflowCell value={secondaryText} tooltipId={secondaryTooltipId}>
                <div className="secondary-text">
                    {secondaryText || ""}
                </div>
            </OverflowCell>

            <OverflowCell value={primaryText} tooltipId={primaryTooltipId}>
                <div className="primary-text">
                    {primaryText || ""}
                </div>
            </OverflowCell>
        </div>
    );
};

DualTextCell.propTypes = {
    primaryText: PropTypes.node,
    secondaryText: PropTypes.node,
    upperText: PropTypes.node,
    belowText: PropTypes.node,
    employeeId: PropTypes.node,
    employeeName: PropTypes.node,
    rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
};
